import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoggingService, MemberQuery, NotificationCenterService, PopulationQuery, SignalRHub } from '@fgb/core';
import { NavigationService, NavigationSettings } from '@fgb/portal-component-library/src/lib/shared/services';
import { combineLatest, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fgb-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.scss'],
})
export class MasterPageComponent implements OnInit, OnDestroy {
  observable$: Subscription;
  private _destroyed$ = new Subject<void>();
  private _destroyRef = inject(DestroyRef);
  navigationSettings: NavigationSettings;
  populationID: string | undefined;
  isTicketTransfer: boolean;

  constructor(
    private signalRHub: SignalRHub,
    private logService: LoggingService,
    private notificationCenterService: NotificationCenterService,
    private navigationService: NavigationService,
    private populationQuery: PopulationQuery,
    private memberQuery: MemberQuery
  ) {}

  ngOnInit() {
    this.signalRHub.connectionEstablished$.pipe(takeUntil(this._destroyed$)).subscribe((connection) => {
      this.logService.debug('SignalR connection', connection);
    });
    this.notificationCenterService.fetchNotificationCenter(5).pipe(takeUntil(this._destroyed$)).subscribe();

    // Subscribe to navigation changes
    this.navigationService.onNavigationChanged.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((navigationSettings) => {
      this.navigationSettings = navigationSettings;
    });

    this.isTicketTransfer = this.populationQuery.userInPopulation(['Ticket Transfer']);

    this.observable$ = combineLatest([this.signalRHub.connectionEstablished$, this.memberQuery.userContext$]).subscribe(
      ([connection, memberDetail]) => {
        this.logService.debug('SignalR connection', connection);
        this.populationID = memberDetail?.populationId;
        document.body.classList.add(`PopId-${this.populationID}`);
      }
    );
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
